import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ObjHlp } from 'src/lib/fliko/helpers/object.helper';
import { StrHlp } from 'src/lib/fliko/helpers/string.helper';
import { EstateType } from 'src/lib/fliko/models/estate/estate.data';
import { LandlordType, ResidentData, ResidentType } from 'src/lib/fliko/models/person/resident.data';
import { SubscribeComponent } from 'src/app/shared/classes/subscribe-component';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { GrammarHelper } from '../../helpers/grammar.helper';
import { LocalizationHelper } from '../../helpers/localization.helper';
import { SelectInputData } from '../../interfaces/select-input-data.interface';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-person-form-data-preview[residentData]',
  templateUrl: './person-form-data-preview.component.html',
  styleUrls: ['./person-form-data-preview.component.scss']
})
export class PersonFormDataPreviewComponent extends SubscribeComponent implements OnChanges {
  @Input() residentData!: ResidentData;
  @Input() residentType: ResidentType = ResidentType.LANDLORD;

  public landlordTypes: SelectInputData<string>[] = [];
  public landlordTypesControl?: FormControl;

  public isCompany: boolean = false;

  public get hasAdditionalData(): boolean {
    const basicDataKeys = ['birthDate', 'PESEL', 'documentNo', 'nationality'];
    return ObjHlp.haveAny(this.residentData, basicDataKeys);
  }

  private estateType = EstateType.PRS;

  ResidentType = ResidentType;

  constructor(
    private ctxDS: ContextDataService,
    private fb: FormBuilder,
    private ls: LocalizationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.estateType = this.ctxDS.peekCurrentEstate()?.type ?? EstateType.PRS;

    const lh = new LocalizationHelper(this.ls);

    this.subscription$.add(
      this.ls.onLanguageChanged$.subscribe(() => {
        // prettier-ignore
        this.landlordTypes = lh.localizeTitle([
          { value: LandlordType.PERSON,   title: 'user.person' },
          { value: LandlordType.COMPANY,  title: 'label.firm' }
        ]);
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    const residentChanged = changes.residentData;
    if (residentChanged && residentChanged.currentValue) {
      if (this.residentType == ResidentType.LANDLORD) {
        this.isCompany = !!this.residentData.NIP;
        this.landlordTypesControl = this.fb.control(this.isCompany ? LandlordType.COMPANY : LandlordType.PERSON);
      }
    }
  }

  public getResidentTypeHR(caseShort: string): string {
    return GrammarHelper.getResidentInCase(this.estateType, this.residentType, caseShort, this.ls);
  }

  public arrayJoined(toJoin: string[] | string | null) {
    return StrHlp.join(toJoin);
  }
}
